<template>
  <section name="boats">
    <div class="boats_sb">
      <div class="wrapper boats_content">
        <div>
          <div class="boat-switch">
            <button
              :class="selectedBoat == 'pequeno' ? 'btn' : 'btn--clear'"
              @click="selectedBoat = 'pequeno'"
              class="uppercase"
            >
              barco pequeno
            </button>
            <button
              :class="selectedBoat == 'grande' ? 'btn' : 'btn--clear'"
              @click="selectedBoat = 'grande'"
              class="uppercase"
            >
              barco grande
            </button>
          </div>
          <div class="boat-card">
            <div v-if="selectedBoat == 'pequeno'">
              <p class="text-pricing">{{ small.subtitle }}</p>
              <p class="text-people">{{ small.content_1 }}</p>
              <ul>
                <li
                  v-for="(item, key) in JSON.parse(small.content_2)"
                  :key="key"
                >
                  <span class="text-highlight">{{ item.name }}</span> -
                  {{ item.qty }}
                </li>
              </ul>
            </div>
            <div v-if="selectedBoat == 'grande'">
              <p class="text-pricing">{{ large.subtitle }}</p>
              <p class="text-people">{{ large.content_1 }}</p>
              <ul>
                <li
                  v-for="(item, key) in JSON.parse(large.content_2)"
                  :key="key"
                >
                  <span class="text-highlight">{{ item.name }}</span> -
                  {{ item.qty }}
                </li>
              </ul>
            </div>
            <button @click="openModal()" class="w-25 btn mt-8">
              Fazer pedido
            </button>
          </div>
          <p class="pb-20">
            Nota: a composição dos barcos é inalterável. poderá sempre
            encomendar peças à parte do barco.
          </p>
        </div>
      </div>
      <order-boat-form
        @closeModal="closeModal()"
        :isModalOpen="isModalOpen"
        :formFields="formFields"
        formTitle="pedido de sushiboat"
        formDescription="Por favor, preenche os campos abaixo. Após o envio do formulário, serás contactado para combinar o local de recolha do barco."
        :defaultSelected="{ type: selectedBoat }"
      >
      </order-boat-form>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    small: {
      required: true,
    },
    large: {
      required: true,
    },
  },
  methods: {
    toggleScroll() {
      document.querySelector("html").classList.toggle("no-scroll");
      document.querySelector("body").classList.toggle("no-scroll");
    },
    openModal() {
      this.toggleScroll();
      this.isModalOpen = true;
    },
    closeModal() {
      this.toggleScroll();
      this.isModalOpen = false;
    },
  },
  data() {
    return {
      selectedBoat: "pequeno",
      isModalOpen: false,
      formFields: {
        name: {
          label: "nome",
          type: "text",
          placeholder: "Introduz o teu nome",
        },
        email: {
          label: "e-mail",
          type: "text",
          placeholder: "Introduz o teu e-mail",
        },
        phone: {
          label: "telefone",
          type: "phone",
          placeholder: "Introduz o teu telemóvel",
        },
        type: {
          label: "tipo",
          placeholder: "small",
          type: "select",
          options: ["big", "small"],
        },
        date: { label: "dia", type: "date" },
        time: { label: "hora", type: "time", placeholder: "14:00" },
        message_content: {
          label: "mensagem",
          type: "textarea",
          placeholder: "Introduz a tua mensagem",
        },
      },
    };
  },
};
</script>
